import { render, staticRenderFns } from "./DmZboziConsent.vue?vue&type=template&id=5c924658&scoped=true&"
import script from "./DmZboziConsent.vue?vue&type=script&lang=js&"
export * from "./DmZboziConsent.vue?vue&type=script&lang=js&"
import style0 from "./DmZboziConsent.vue?vue&type=style&index=0&id=5c924658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c924658",
  null
  
)

export default component.exports